var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promotion-id-description"},[_c('p',{staticClass:"red"},[_vm._v(" ※"+_vm._s(_vm.aspData.aspName)+"は他のASPと違い、プログラムIDを自分で命名して、それをアフィリリンクに付与する必要があるので、このマニュアルを注意して読んでください。 ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }